// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1F9Os","title":"Info_title__3Sqad","selects":"Info_selects__HOfh_","requiredAsterisk":"Info_requiredAsterisk__6c4bk"};